import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Team", -1)
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Bij team vanaf", -1)
const _hoisted_4 = { class: "error" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Coureur", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Vervangt vanaf", -1)
const _hoisted_8 = { class: "error" }

import {onMounted, ref} from "vue";
	import {useRouter} from 'vue-router';
	import {FetchData} from "../utils/FetchData";
	import DriverCard from '../components/DriverCard.vue';
	import FetchOptions from "../interfaces/FetchOptions";
	import ModalWindow from '../components/ModalWindow.vue';
	import LoadingCircleAnimation from '../components/LoadingCircleAnimation.vue';
	import {DateFormatter, DateToTimestamp} from "../utils/DateFormatter";
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'DriversPage',
  setup(__props) {

	const drivers = ref([]);
	const router = useRouter();
	const deletingDriver = ref({});
	const modalDeleteVisible = ref(false);
	const loading = ref(true);

	const teams = ref([]);
	const editingDriver = ref({});
	const modalTeamVisible = ref(false);
	const modalReplacementVisible = ref(false);
	const selectedDate = ref();

	const newTeam = ref(0);
	const replacer = ref(0);
	const availableDrivers = ref([]);
	const errorMessage = ref('');

	onMounted(() => {
		RetrieveDrivers();
	});

	async function RetrieveDrivers() {
		const data = await FetchData('drivers');
		if(!data.isError) {
			//data.data.sort((a: object, b: object) => (a.team_id > b.team_id) ? 1 : -1);
			data.data.sort((a: object, b: object) => {
				if(a.team_id > b.team_id)
					return 1;
				else if(a.team_id < b.team_id)
					return -1;

				if(a.with_team_since > b.with_team_since)
					return 1;
				else if(a.with_team_since < b.with_team_since)
					return -1;

				if(a.name > b.name)
					return 1;

				return -1;
			});
			drivers.value = data.data;
		}

		loading.value = false;
	}

	async function RetrieveTeams() {
		const data = await FetchData('teams');
		if(!data.isError)
			teams.value = data.data;
	}

	function editTeams() {
		router.push(router.currentRoute.value.path + '/teams');
	}

	function addDriver() {
		drivers.value.unshift({team: {}, 'with_team_since': Date.now() / 1000});
	}

	function onUpdateDriver(driver: object, index: number) {
		drivers.value[index] = driver;
	}

	function onDeleteDriver(driver: object) {
		if(driver.id == undefined) {
			drivers.value.shift();
			return;
		}

		modalDeleteVisible.value = true;
		deletingDriver.value = driver;
	}

	async function confirmAccept() {
		modalDeleteVisible.value = false;

		const options: FetchOptions = {
			method: 'DELETE'
		};
		const data = await FetchData("drivers/" + deletingDriver.value.id, options);
		if(!data.isError)
			drivers.value = drivers.value.filter(x => x.id != deletingDriver.value.id);
	}

	function confirmDeny() {
		modalDeleteVisible.value = false;
	}

	function onEditTeam(driver: object) {
		if(teams.value.length == 0)
			RetrieveTeams();

		editingDriver.value = driver;
		modalTeamVisible.value = true;
		errorMessage.value = '';

		selectedDate.value = DateFormatter(Date.now(), true).dateInput;
	}

	async function teamSave() {
		errorMessage.value = '';

		if(newTeam.value == 0) {
			errorMessage.value = "Er is geen team gekozen.";
			return;
		}

		if(newTeam.value == editingDriver.value.team_id) {
			errorMessage.value = "Het nieuwe team is hetzelfde als het oude team."
			return;
		}

		if(editingDriver.value.id == undefined)
			return;

		const body = {
			'team_id': newTeam.value,
			'with_team_since': DateToTimestamp(selectedDate.value)
		}

		const options: FetchOptions = {
			method: 'PATCH',
			headers: {
				"Content-Type": 'application/json'
			},
			body: JSON.stringify(body)
		};

		const data = await FetchData('drivers/' + editingDriver.value.id, options);
		if(!data.isError) {
			drivers.value.push(data.data);
			modalTeamVisible.value = false;
			emitter.emit('showMessage', {message: 'Team verwisseld', header: 'Gelukt'});
		}
	}

	function teamCancel() {
		modalTeamVisible.value = false;
	}

	function onReplaceDriver(driver: object) {
		editingDriver.value = driver;
		modalReplacementVisible.value = true;
		errorMessage.value = '';

		selectedDate.value = DateFormatter(Date.now(), true).dateInput;

		if(driver.replaced_by == null)
			replacer.value = 0;
		else
			replacer.value = driver.replaced_by;

		availableDrivers.value = drivers.value.filter(x => x.is_replacement && x.team_id == driver.team_id);
		if(availableDrivers.value.length == 0)
			availableDrivers.value.push({name: "Geen geldige vervangers gevonden", id: 0});
	}

	async function replaceSave() {
		errorMessage.value = '';

		if(replacer.value == 0) {
			errorMessage.value = "Geen geldige vervanger geselecteerd";
			return;
		}

		const body = {
			id: editingDriver.value.id,
			'replaced_by': replacer.value,
			'replaced_after': DateToTimestamp(selectedDate.value)
		};

		const options: FetchOptions = {
			method: 'PATCH',
			headers: {
				"Content-Type": 'application/json'
			},
			body: JSON.stringify(body)
		};

		const data = await FetchData('drivers/' + editingDriver.value.id, options);
		if(!data.isError) {
			modalReplacementVisible.value = false;
			emitter.emit('showMessage', {message: 'Coureur vervangen', header: 'Gelukt'});
		}
	}

	async function replaceStop() {
		const body = {
			id: editingDriver.value.id,
			'replaced_by': null,
			'replaced_after': DateToTimestamp(selectedDate.value)
		};

		const options: FetchOptions = {
			method: 'PATCH',
			headers: {
				"Content-Type": 'application/json'
			},
			body: JSON.stringify(body)
		};

		const data = await FetchData('drivers/' + editingDriver.value.id, options);
		if(!data.isError) {
			modalReplacementVisible.value = false;
			emitter.emit('showMessage', {message: 'Coureur wordt niet meer vervangen', header: 'Gelukt'});
		}
	}

	function replaceCancel() {
		modalReplacementVisible.value = false;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "content-box",
      onClick: editTeams
    }, " Teams bewerken "),
    _createElementVNode("button", {
      class: "content-box",
      onClick: addDriver
    }, " Coureur toevoegen "),
    (!loading.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(drivers.value, (driver, index) => {
          return (_openBlock(), _createBlock(DriverCard, {
            key: driver,
            driver: driver,
            index: index,
            onUpdateDriver: onUpdateDriver,
            onDeleteDriver: onDeleteDriver,
            onEditTeam: onEditTeam,
            onReplaceDriver: onReplaceDriver
          }, null, 8, ["driver", "index"]))
        }), 128))
      : (loading.value)
        ? (_openBlock(), _createBlock(LoadingCircleAnimation, { key: 1 }))
        : _createCommentVNode("", true),
    _withDirectives(_createVNode(ModalWindow, null, {
      header: _withCtx(() => [
        _createTextVNode(" Bevestigen ")
      ]),
      content: _withCtx(() => [
        _createTextVNode(" Weet je zeker dat je coureur '" + _toDisplayString(deletingDriver.value.name) + "' en alle bijbehorende gegevens wilt verwijderen? ", 1)
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", { onClick: confirmAccept }, "Ja"),
        _createElementVNode("button", { onClick: confirmDeny }, "Nee")
      ]),
      _: 1
    }, 512), [
      [_vShow, modalDeleteVisible.value]
    ]),
    _withDirectives(_createVNode(ModalWindow, null, {
      header: _withCtx(() => [
        _createTextVNode(" Team verwisselen ")
      ]),
      content: _withCtx(() => [
        _hoisted_1,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newTeam).value = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teams.value, (team) => {
            return (_openBlock(), _createElementBlock("option", {
              key: team,
              value: team.id
            }, _toDisplayString(team.name), 9, _hoisted_2))
          }), 128))
        ], 512), [
          [_vModelSelect, newTeam.value]
        ]),
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDate).value = $event)),
          class: "date",
          type: "date"
        }, null, 512), [
          [_vModelText, selectedDate.value]
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(errorMessage.value), 1)
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", { onClick: teamSave }, "Opslaan"),
        _createElementVNode("button", { onClick: teamCancel }, "Annuleren")
      ]),
      _: 1
    }, 512), [
      [_vShow, modalTeamVisible.value]
    ]),
    _withDirectives(_createVNode(ModalWindow, null, {
      header: _withCtx(() => [
        _createTextVNode(" Coureur vervangen ")
      ]),
      content: _withCtx(() => [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((replacer).value = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDrivers.value, (driver) => {
            return (_openBlock(), _createElementBlock("option", {
              key: driver,
              value: driver.id
            }, _toDisplayString(driver.name), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, replacer.value]
        ]),
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedDate).value = $event)),
          class: "date",
          type: "date"
        }, null, 512), [
          [_vModelText, selectedDate.value]
        ]),
        _createElementVNode("p", _hoisted_8, _toDisplayString(errorMessage.value), 1)
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", { onClick: replaceSave }, "Opslaan"),
        _createElementVNode("button", { onClick: replaceStop }, "Stoppen met vervangen"),
        _createElementVNode("button", { onClick: replaceCancel }, "Annuleren")
      ]),
      _: 1
    }, 512), [
      [_vShow, modalReplacementVisible.value]
    ])
  ], 64))
}
}

})